<template>
  <div class="left400 fl">
    <div class="bor">
      <div class="tit-mod-secs clearfix">
        <h3 class="fl font-s16">{{ typeName }}</h3>
        <a
          :href="`/info?type=${arr[0].type}`"
          class="more2 font-s14"
          target="_blank"
          >查看更多&gt;</a
        >
      </div>
      <div class="blank20"></div>
      <dl class="fix">
        <dt>
          <a :href="`/detail?id=${arr[0].id}`" target="_blank">
            <img :src="arr[0].image" :alt="arr[0].title"
          /></a>
        </dt>
        <dd>
          <a
            target="_blank"
            :title="arr[0].title"
            :href="`/detail?id=${arr[0].id}`"
            >{{ arr[0].title }}</a
          >
          <p v-html="arr[0].content"></p>
        </dd>
        <div class="blank10"></div>
      </dl>
      <div class="blank10"></div>

      <superslide :options="options" class="slideBox">
      <div class="lx-index-news">
        <ul class="clearfix">
          <li
            v-for="(item, index) in arr.slice(1, 10)"
            :key="index"
            class="pr fl"
          >
            <span>{{ item.create_time }}</span
            ><a
              target="_blank"
              :title="item.title"
              :href="`/detail?id=${item.id}`"
              >{{ item.title }}</a
            >
          </li>
        </ul>
      </div>
      </superslide>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: Number,
      default: () => 1,
    },
    arr: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    typeName() {
      let returnVal;
      switch (Number(this.type)) {
        case 1:
          returnVal = "政策新闻/行业动态";
          break;
        case 2:
          returnVal = "通知公告";
          break;
        case 3:
          returnVal = "图片新闻";
          break;
        default:
          returnVal = "名企招聘";
          break;
      }
      return returnVal;
    },
  },
  data() {
    return {
        options: {
          mainCell: ".lx-index-news ul",
          autoPlay: true,
          effect: "topMarquee",
          vis: 9,
          interTime: 70,
        }
    };
  },
  created() {},
};
</script>
<style lang="scss" scoped>
a,
a:link {
  cursor: pointer;
  color: #333;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  color: #04407d;
}

.left820 {
  width: 795px;
}
.left400 {
  width: 580px;
  font-family: "Microsoft YaHei", "微软雅黑" !important;
}
.left400 .bor {
  width: 580px;
  padding-top: 20px;
}
.blank20 {
  clear: both;
  height: 20px;
  overflow: hidden;
  display: block;
}
.left400 dl {
  border-bottom: 1px dotted #c6c6c6;
  margin: 0 0px;
}
.left400 dl dt {
  width: 150px;
  height: 100px;
  text-align: center;
  float: left;
  margin-right: 10px;
  overflow: hidden;
}
.left400 dl dt img {
  height: 100px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.left400 dl dt :hover img {
  -webkit-transform: scale(1.06, 1.06);
  -moz-transform: scale(1.06, 1.06);
  -ms-transform: scale(1.06, 1.06);
  -o-transform: scale(1.06, 1.06);
  transform: scale(1.06, 1.06);
}
.left400 dl dd {
  width: 420px;
  float: left;
  overflow: hidden;
}
.left400 dl dd a {
  display: block;
  width: 420px;
  font: 700 15px/24px "Microsoft YaHei";
  padding-bottom: 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.left400 dl dd p {
  height: 75px;
  overflow-y: hidden;
  font: 14px/24px "Microsoft YaHei";
  color: #606060;
}
.blank10 {
  clear: both;
  height: 10px;
  overflow: hidden;
  display: block;
  font-size: 1px;
}

.lx-index-news {
    height: 315px;
  overflow: hidden;
}
.lx-index-news ul {
  margin: 0 15px 10px;
}
.lx-index-news ul li {
  height: 35px;
  line-height: 35px;
  vertical-align: top;
}
.lx-index-news ul li a {
  float: left;
  display: block;
  height: 35px;
  line-height: 35px;
  width: 450px;
  font-size: 16px;
  overflow: hidden;
  font-family: "Microsoft YaHei", "微软雅黑" !important;
}
.lx-index-news ul li span {
  float: right;
  color: #666;
  text-align: right;
  width: 100px;
  font-family: "Microsoft YaHei", "微软雅黑" !important;
}
</style>
